/**
 * Format error messages for user display.
 * Makes technical errors more user-friendly (truncation, strip prefixes).
 * @param {string|Error} error - Error string or Error object
 * @param {number} maxLength - Max chars to show (default 200)
 * @returns {string} Formatted message
 */
export function formatErrorMessage(error, maxLength = 200) {
  if (error == null) return '';
  try {
    const msg = typeof error === 'string' ? error : (error?.message ?? String(error));
    let out = msg
      .replace(/^Error:\s*/i, '')
      .replace(/^TypeError:\s*/i, '')
      .trim();
    if (out.length > maxLength) {
      out = out.slice(0, maxLength) + '…';
    }
    return out || 'An unexpected error occurred.';
  } catch {
    return 'An unexpected error occurred.';
  }
}
